import type { ComponentProps } from "react"

import {
  Tooltip as KitTooltip,
  TooltipTrigger,
} from "@/components/ui-kit/untitled/base/tooltip/tooltip"

export { TooltipTrigger }
export type TooltipProps = ComponentProps<typeof KitTooltip>

/*
 * A tooltip is print: the kit bubble on `bg-primary-solid`,
 * which this theme routes to print.900, with stone.50 text and the second line
 * in `text-tooltip-supporting-text` (stone.50 at the body alpha). A paper
 * tooltip over a paper table vanished. The kit owns the bubble's classes and
 * takes no className for it, so its shadow stays the kit's `shadow-lg` rather
 * than `shadow-lift`; `arrow` and `delay` pass through.
 */
export function Tooltip(props: TooltipProps) {
  return <KitTooltip {...props} />
}
